import {FileModel} from "@renta-apps/athenaeum-toolkit";

export default class ReturnedMassProduct
{
    public id: string = "";

    public name: string | null = null;

    public comment: string | null = null;

    public externalProductGroupId: string = "";

    public contractExternalId: string = "";

    public constructionSiteExternalId: string = "";

    public customerName: string = "";

    public returnDate: Date = new Date();

    public returnedAmount: number = 0;

    public brokenAmount: number = 0;

    public invoicedAmount: number | null = null;

    public pictures: FileModel[]  | null = [];
    
    public invoiced : boolean = false;

    public isReturnedMassProduct: boolean = true;
}